<template>
  <div>
    <div class="content">
      <div class="modular-title">
        <div class="title-left">
          <div class="title-line"></div>
          <div>佣金提现</div>
        </div>
      </div>

      <div>
        <div class="tx-input">
          <span>￥</span>
          <input type="number" v-model="price" />
        </div>
        <div class="tx-ps">
          当前余额{{ priData.price }}元，<span @click="upall">全部提现</span>
        </div>
      </div>

      <div class="modular-title">
        <div class="title-left">
          <div class="title-line"></div>
          <div>选择提现方式</div>
        </div>
      </div>

      <div class="cashout-type">
        <!-- <div class="cashout-type-item" @click="type = 1">
          <img src="../../../assets/teacher/wechat.png" alt="" />
          <span>微信</span>
          <div class="radio">
            <img
              src="../../../assets/teacher/radio_checked.png"
              v-if="type == 1"
            />
            <img src="../../../assets/teacher/radio.png" v-else />
          </div>
        </div> -->
        <div class="cashout-type-item" @click="type = 2">
          <img src="../../../assets/teacher/alipay.png" alt="" />
          <span>支付宝</span>
          <div class="radio">
            <img
              src="../../../assets/teacher/radio_checked.png"
              v-if="type == 2"
              alt=""
            />
            <img src="../../../assets/teacher/radio.png" alt="" v-else />
          </div>
        </div>
      </div>

      <div class="input-box">
        <span>真实姓名</span>
        <input type="text" placeholder="请输入真实姓名" v-model="name" />
      </div>
      <div class="input-box">
        <span>收款账号</span>
        <input type="text" placeholder="请输入收款账号" v-model="account" />
      </div>

      <div class="submit" @click="submitFn">确定提现</div>
    </div>
    <div class="list">
      <div class="list-title">
        <div class="title-line"></div>
        <div class="title">佣金明细</div>
        <div class="list-more" @click="$router.push('yj')">
          <span>查看更多</span>
          <i class="iconfont icon-a-LeftArrow"></i>
        </div>
      </div>

      <!-- <div class="list-item" @click="$router.push('commissionDetails')">
        <div>
          <p class="list-item-title">上学考试</p>
          <p class="list-item-time">2020-04-09 10:30</p>
        </div>
        <div class="list-item-state">已完成</div>
        <div class="list-item-more">
          <span class="num">+400</span>
          <i class="iconfont icon-a-LeftArrow"></i>
        </div>
      </div> -->
      <List
        :loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          @click="handleClick(item)"
           
        >
          <div class="list-item">
            <div>
              <p class="list-item-title">{{ item.title }}</p>
              <p class="list-item-time">{{ item.time }}</p>
            </div>
            <div class="list-item-state"></div>
            <div class="list-item-more">
              <span class="num" v-if="item.type == 1">+{{ item.price }}</span>
              <span class="num" style="color:#F9647D" v-if="item.type == 2">-{{ item.price }}</span>
              <!-- <i class="iconfont icon-a-LeftArrow"></i> -->
            </div>
          </div>
        </div>
      </List>
    </div>
    <div class="mask" v-if="maskShow">
      <Loading color="#fff"></Loading>
    </div>
  </div>
</template>

<script>
/**
@description:提现
@createTime:2021-09-01
@create:wq
*/
import { List ,Loading } from "vant";
export default {
  name: "",
  props: {},
  components: { List ,Loading },
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      page: 1,
      priData: {},
      type: 1,
      name: "",
      account: "",
      price: 0,
      maskShow:false,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.priData = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    submitFn() {
      if (this.price <= 0) {
        this.Toast("提现金额不能小于0");
        return;
      } else if (this.price > Number(this.priData.price)) {
        this.Toast("提现金额不足");
        return;
      }
      let data = {
        type: this.type,
        name: this.name,
        account: this.account,
        price: this.price,
      };
      this.maskShow = true;
      this.api.withdrawal(data).then(() => {
        this.Toast.success("提现成功");
        this.maskShow = false;
        this.priData.price = Number(this.priData.price - this.price)
        localStorage.setItem(JSON.stringify(this.priData))
      },() => {
        this.maskShow = false;
      });
    },
    upall() {
      this.price = this.priData.price;
    },
    handleClick(item) {
      if (item.oid == 0) return;
      this.$router.push({ query: { item: item }, path: "commissionDetails" });
    },
    onLoad() {
      this.getList();
      this.page++;
    },
    getList() {
      this.api.myDetailed({ page: this.page }).then((res) => {
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0 0.24rem;
  padding-top: 0.16rem;
}
.modular-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title-left {
    font-size: 0.32rem;
    font-weight: 400;
    color: #666666;
    display: flex;
    align-items: center;
    .title-line {
      width: 4px;
      height: 16px;
      background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
      opacity: 1;
      border-radius: 0px 4px 4px 0px;
      margin-right: 6px;
    }
  }
  .look-more {
    font-size: 0.22rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    span {
      margin-right: 6px;
    }
    i {
      font-size: 0.2rem;
    }
  }
}
.tx-input {
  border-bottom: 1px solid #f0f0f0;
  padding: 0.32rem 0;

  font-size: 0.6rem;
  font-weight: bold;
  color: #333333;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
  input {
    border: none;
    // flex: 1;
    width: 100%;
    margin-left: 0.2rem;
  }
}
.tx-ps {
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  margin-top: 0.1rem;
  margin-bottom: 0.46rem;

  span {
    color: #4fd9d5;
  }
}

.cashout-type {
  .cashout-type-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    padding: 0.26rem 0;
    &:last-child {
      border-bottom: none;
    }
    img {
      width: 0.8rem;
      margin-right: 0.18rem;
    }
    span {
      flex: 1;
      font-size: 0.3rem;
      font-weight: 400;
      color: #333333;
    }
    .radio {
      width: 0.42rem;
      height: 0.42rem;
      // background: #f5f5f5;
      // border: 1px solid #e6e6e6;
      border-radius: 50%;
      // flex-shrink: 0;
      img {
        width: 100%;
      }
    }
    .radio-checked {
      width: 0.42rem;
      height: 0.42rem;
      background: #4fd9d5;
      border: 1px solid #aaefed;
      border-radius: 50%;
      flex-shrink: 0;
    }
  }
}

.input-box {
  margin: 0.24rem 0;
  height: 0.8rem;
  background: #f5f5f5;
  border: 1px solid #e6e6e6;
  border-radius: 0.4rem;
  box-sizing: border-box;
  padding: 0 0.18rem;
  display: flex;
  align-items: center;
  span {
    font-size: 0.28rem;
    font-weight: 400;
    color: #333333;
    margin-right: 0.46rem;
  }
  input {
    height: 100%;

    flex: 1;
    font-size: 0.28rem;
    font-weight: 400;
    border: none;
    background-color: transparent;
  }
}
.submit {
  height: 0.8rem;
  background: #4fd9d5;
  box-shadow: 0px 3px 6px rgba(79, 217, 213, 0.3);
  border-radius: 0.4rem;

  font-size: 0.28rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.28rem;
  margin-top: 0.36rem;
}
.list {
  .list-title {
    padding: 0 0.24rem;
    height: 0.64rem;
    background: #edfbfb;
    display: flex;
    align-items: center;
    .title-line {
      width: 0.08rem;
      height: 0.34rem;
      background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
      border-radius: 0px 2px 2px 0px;
      margin-right: 0.22rem;
    }
    .title {
      flex: 1;
      font-size: 0.32rem;
      font-weight: 400;
      color: #666666;
      margin-top: 2px;
    }
    .list-more {
      font-size: 0.22rem;
      font-weight: 400;
      color: #999999;
      display: flex;
      align-items: center;
      i {
        font-size: 12px;
        color: #999999;
        margin-left: 0.1rem;
      }
    }
  }
  .list-item {
    margin: 0 0.24rem;
    height: 1.3rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    .list-item-title {
      font-size: 0.3rem;
      font-weight: 400;
      color: #666666;
    }
    .list-item-time {
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
    }
    .list-item-state {
      flex: 1;
      text-align: right;

      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      margin-right: 0.58rem;
    }
    .list-item-more {
      .num {
        font-size: 0.3rem;
        font-weight: 400;
        color: #ffa380;
        margin-right: 0.12rem;
      }
      i {
        font-size: 12px;
        color: #cccccc;
      }
    }
  }
}
.mask{
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.4);
  z-index: 888;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
}
</style>
